/* SpielzeugShop24 – Theme-JS (Präfix sps). Vanilla, keine Abhängigkeiten. */
(function () {
  'use strict';
  var SPS = window.SPS = window.SPS || {};
  SPS.moneyFormat = SPS.moneyFormat || '€ {{amount_with_comma_separator}}';
  SPS.routes = SPS.routes || { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartGet: '/cart.js', search: '/search', suggest: '/search/suggest.json', recommendations: '/recommendations/products' };
  SPS.strings = SPS.strings || {};

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); };

  /* ---------- Geld ---------- */
  SPS.money = function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var format = SPS.moneyFormat;
    function delimit(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? (decimal + parts[1]) : '';
      return dollars + c;
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(placeholder, value);
  };

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  SPS.toast = function (html, isError) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sps-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    toastEl.classList.toggle('sps-toast--error', !!isError);
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3500);
  };

  /* ---------- Drawer (Menü, Warenkorb, Filter) ---------- */
  SPS.openDrawer = function (id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.removeAttribute('aria-hidden'); document.body.classList.add('sps-lock');
    var focus = d.querySelector('[data-sps-autofocus], .sps-drawer__close'); if (focus) focus.focus();
  };
  SPS.closeDrawer = function (id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.sps-drawer.is-open')) document.body.classList.remove('sps-lock');
  };
  on(document, 'click', function (e) {
    var open = e.target.closest('[data-sps-open]');
    if (open) { e.preventDefault(); SPS.openDrawer(open.getAttribute('data-sps-open')); return; }
    var close = e.target.closest('[data-sps-close]');
    if (close) { e.preventDefault(); SPS.closeDrawer(close.getAttribute('data-sps-close')); return; }
    if (e.target.classList.contains('sps-drawer__backdrop')) { var d = e.target.closest('.sps-drawer'); if (d) SPS.closeDrawer(d.id); }
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') $$('.sps-drawer.is-open').forEach(function (d) { SPS.closeDrawer(d.id); }); });

  /* ---------- Warenkorb ---------- */
  var Cart = SPS.cart = {
    data: null,
    fetch: function () { return fetch(SPS.routes.cartGet, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { Cart.data = c; Cart.render(); return c; }); },
    add: function (id, qty, props) {
      var body = { items: [{ id: parseInt(id, 10), quantity: qty || 1 }] };
      if (props) body.items[0].properties = props;
      return fetch(SPS.routes.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    change: function (key, qty) {
      return fetch(SPS.routes.cartChange, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    updateCount: function (n) {
      $$('[data-sps-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', !n); });
    },
    render: function () {
      var c = Cart.data; if (!c) return;
      Cart.updateCount(c.item_count);
      var list = $('[data-sps-cart-items]'); if (!list) return;
      var foot = $('[data-sps-cart-foot]');
      if (!c.items.length) {
        list.innerHTML = '<div class="sps-cart__empty">' + SPS.icon('cart') + '<p>' + (SPS.strings.cartEmpty || 'Dein Warenkorb ist leer.') + '</p><a class="sps-btn sps-btn--primary" href="/collections/all">' + (SPS.strings.continue || 'Weiter stöbern') + '</a></div>';
        if (foot) foot.hidden = true; return;
      }
      if (foot) foot.hidden = false;
      list.innerHTML = c.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x200$1$2') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="sps-cart__variant">' + it.variant_title + '</div>' : '';
        return '<li class="sps-cart__item" data-key="' + it.key + '">' +
          (img ? '<a href="' + it.url + '"><img src="' + img + '" alt="" loading="lazy" width="72" height="72"></a>' : '<span></span>') +
          '<div><a class="sps-cart__title" href="' + it.url + '">' + it.product_title + '</a>' + variant +
          '<div class="sps-cart__line"><div class="sps-qty sps-qty--sm"><button type="button" data-sps-cart-qty="-1" aria-label="Weniger">−</button><input type="number" min="0" value="' + it.quantity + '" data-sps-cart-input aria-label="Menge"><button type="button" data-sps-cart-qty="1" aria-label="Mehr">+</button></div>' +
          '<span class="sps-cart__price">' + SPS.money(it.final_line_price) + '</span></div></div>' +
          '<button type="button" class="sps-cart__remove" data-sps-cart-remove aria-label="Entfernen">' + SPS.icon('x') + '</button></li>';
      }).join('');
      var total = $('[data-sps-cart-total]'); if (total) total.textContent = SPS.money(c.total_price);
      var ship = $('[data-sps-cart-ship]');
      if (ship) {
        var limit = parseInt(ship.getAttribute('data-limit'), 10) || 0;
        if (limit > 0) {
          var rest = limit - c.total_price;
          var pct = Math.min(100, Math.round(c.total_price / limit * 100));
          ship.querySelector('[data-text]').innerHTML = rest > 0
            ? (SPS.strings.shipRest || 'Noch <b>{amount}</b> bis zum Gratisversand').replace('{amount}', SPS.money(rest))
            : (SPS.strings.shipFree || '<b>Gratisversand</b> – du hast die Grenze erreicht.');
          ship.querySelector('.sps-cart__bar i').style.width = pct + '%';
        }
      }
    },
    open: function () { SPS.openDrawer('sps-cart-drawer'); }
  };
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-sps-cart-qty]');
    if (b) {
      var li = b.closest('.sps-cart__item'); var input = li.querySelector('[data-sps-cart-input]');
      var q = Math.max(0, parseInt(input.value, 10) + parseInt(b.getAttribute('data-sps-cart-qty'), 10));
      input.value = q; Cart.change(li.getAttribute('data-key'), q); return;
    }
    var r = e.target.closest('[data-sps-cart-remove]');
    if (r) { var li2 = r.closest('.sps-cart__item'); li2.style.opacity = '.4'; Cart.change(li2.getAttribute('data-key'), 0); }
  });
  on(document, 'change', function (e) {
    var input = e.target.closest('[data-sps-cart-input]');
    if (input) { var li = input.closest('.sps-cart__item'); Cart.change(li.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0)); }
  });

  /* In den Warenkorb – Buttons/Formulare */
  function addFromButton(btn, buyNow) {
    var form = btn.closest('form');
    var id, qty = 1, props = null;
    if (form) {
      var idEl = form.querySelector('[name="id"]'); id = idEl ? idEl.value : null;
      var qEl = form.querySelector('[name="quantity"]'); qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
      var propEls = form.querySelectorAll('[name^="properties["]');
      if (propEls.length) { props = {}; propEls.forEach(function (p) { var k = p.name.match(/properties\[(.+)\]/)[1]; if (p.value) props[k] = p.value; }); }
    } else {
      id = btn.getAttribute('data-sps-add'); qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    }
    if (!id) return;
    btn.classList.add('is-loading'); btn.disabled = true;
    Cart.add(id, qty, props).then(function () {
      if (buyNow) { window.location.href = '/checkout'; return; }
      return Cart.fetch().then(function () {
        btn.classList.remove('is-loading'); btn.disabled = false;
        if ($('#sps-cart-drawer')) Cart.open(); else SPS.toast((SPS.strings.added || 'In den Warenkorb gelegt') + ' · <a href="' + SPS.routes.cart + '">' + (SPS.strings.toCart || 'Zum Warenkorb') + '</a>');
      });
    }).catch(function (err) {
      btn.classList.remove('is-loading'); btn.disabled = false;
      SPS.toast((err && (err.description || err.message)) || 'Leider nicht möglich.', true);
    });
  }
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-sps-add], [data-sps-atc]');
    if (b) { e.preventDefault(); addFromButton(b, false); return; }
    var n = e.target.closest('[data-sps-buynow]');
    if (n) { e.preventDefault(); addFromButton(n, true); }
  });
  on(document, 'submit', function (e) {
    var f = e.target.closest('form[data-sps-atc-form]');
    if (f) { e.preventDefault(); var b = f.querySelector('[data-sps-atc]') || f.querySelector('[type=submit]'); addFromButton(b, false); }
  });

  /* Mengen-Stepper */
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-sps-qty]'); if (!b) return;
    var wrap = b.closest('.sps-qty'); var input = wrap.querySelector('input'); if (!input || input.hasAttribute('data-sps-cart-input')) return;
    var min = parseInt(input.min, 10) || 1; var max = parseInt(input.max, 10) || 9999;
    var v = (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-sps-qty'), 10);
    input.value = Math.min(max, Math.max(min, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Merkliste (lokal) ---------- */
  var WISH_KEY = 'sps_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function wishSet(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { } }
  function wishSync() { var list = wishGet(); $$('[data-sps-wish]').forEach(function (b) { var onList = list.indexOf(b.getAttribute('data-sps-wish')) > -1; b.classList.toggle('is-on', onList); b.setAttribute('aria-pressed', onList ? 'true' : 'false'); }); }
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-sps-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-sps-wish'); var list = wishGet(); var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    wishSet(list); wishSync();
    document.dispatchEvent(new CustomEvent('sps:wishlist', { detail: { handle: h, list: list } }));
    SPS.toast(i > -1 ? (SPS.strings.wishRemoved || 'Von der Merkliste entfernt') : (SPS.strings.wishAdded || 'Auf die Merkliste gesetzt'));
  });

  /* ---------- Suche mit Vorschlägen ---------- */
  function initSearch(box) {
    var input = box.querySelector('input[type=search], input[name=q]'); var res = box.querySelector('.sps-search__results'); if (!input || !res) return;
    var t, last = '';
    function close() { res.classList.remove('is-open'); res.innerHTML = ''; }
    on(input, 'input', function () {
      clearTimeout(t); var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      t = setTimeout(function () {
        if (q === last) return; last = q;
        fetch(SPS.routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); }).then(function (j) {
            var items = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!items.length) { close(); return; }
            res.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_100x100$1$2') : '';
              return '<a class="sps-search__result" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="44" height="44">' : '<span></span>') + '<span>' + p.title + '<small>' + (p.vendor || '') + (p.price ? ' · ' + SPS.money(Math.round(parseFloat(p.price) * 100)) : '') + '</small></span></a>';
            }).join('') + '<a class="sps-search__all" href="' + SPS.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">' + (SPS.strings.allResults || 'Alle Ergebnisse anzeigen') + '</a>';
            res.classList.add('is-open');
          }).catch(close);
      }, 220);
    });
    on(document, 'click', function (e) { if (!box.contains(e.target)) close(); });
    on(input, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    var btns = $$('[role=tab]', root); var panels = $$('[role=tabpanel]', root);
    function activate(id, focus) {
      btns.forEach(function (b) { var onB = b.getAttribute('aria-controls') === id; b.setAttribute('aria-selected', onB ? 'true' : 'false'); b.tabIndex = onB ? 0 : -1; if (onB && focus) b.focus(); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
    }
    btns.forEach(function (b, i) {
      on(b, 'click', function () { activate(b.getAttribute('aria-controls')); });
      on(b, 'keydown', function (e) { var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null; if (n == null) return; n = (n + btns.length) % btns.length; activate(btns[n].getAttribute('aria-controls'), true); });
    });
    on(document, 'click', function (e) { var l = e.target.closest('[data-sps-tab]'); if (l && root.contains(document.getElementById(l.getAttribute('data-sps-tab')))) { e.preventDefault(); activate(l.getAttribute('data-sps-tab')); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
  }

  /* ---------- Galerie ---------- */
  function initGallery(g) {
    var stage = $('[data-sps-stage]', g); var thumbs = $$('.sps-thumb', g);
    thumbs.forEach(function (t) {
      on(t, 'click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active');
        var tpl = t.querySelector('template');
        var current = stage.querySelector('[data-sps-media]'); if (current) current.remove();
        var node = tpl ? tpl.content.firstElementChild.cloneNode(true) : null;
        if (node) { node.setAttribute('data-sps-media', ''); stage.appendChild(node); }
      });
    });
    var zoom = $('[data-sps-zoom]', g);
    on(zoom, 'click', function () { var img = stage.querySelector('img[data-sps-media]'); if (img && img.getAttribute('data-full')) window.open(img.getAttribute('data-full'), '_blank'); });
    // Varianten-Bildwechsel
    on(document, 'sps:variant', function (e) {
      var v = e.detail; if (!v || !v.featured_media) return;
      var t = thumbs.filter(function (x) { return x.getAttribute('data-media-id') === String(v.featured_media.id); })[0]; if (t) t.click();
    });
  }

  /* ---------- Varianten (Produktseite) ---------- */
  function initVariants(form) {
    var json = form.querySelector('[data-sps-variants]'); if (!json) return;
    var variants = JSON.parse(json.textContent); var selects = $$('select[data-sps-option]', form); var idInput = form.querySelector('[name="id"]');
    function current() { var opts = selects.map(function (s) { return s.value; }); return variants.filter(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); })[0]; }
    function apply(v) {
      var atc = form.querySelector('[data-sps-atc]'); var now = form.querySelector('[data-sps-buynow]');
      var priceEl = $('[data-sps-price]'); var cmpEl = $('[data-sps-compare]'); var saveEl = $('[data-sps-save]'); var stock = $('[data-sps-stock]'); var sku = $('[data-sps-sku]');
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = SPS.strings.unavailable || 'Nicht verfügbar'; } return; }
      idInput.value = v.id;
      if (priceEl) { priceEl.textContent = SPS.money(v.price); priceEl.classList.toggle('is-sale', v.compare_at_price > v.price); }
      if (cmpEl) { cmpEl.hidden = !(v.compare_at_price > v.price); cmpEl.textContent = v.compare_at_price ? SPS.money(v.compare_at_price) : ''; }
      if (saveEl) { if (v.compare_at_price > v.price) { saveEl.hidden = false; saveEl.textContent = (SPS.strings.save || 'Du sparst {amount} ({pct})').replace('{amount}', SPS.money(v.compare_at_price - v.price)).replace('{pct}', Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'); } else saveEl.hidden = true; }
      if (sku) sku.textContent = v.sku || '';
      if (atc) { atc.disabled = !v.available; atc.querySelector('span') ? (atc.querySelector('span').textContent = v.available ? (SPS.strings.addToCart || 'In den Warenkorb') : (SPS.strings.soldOut || 'Ausverkauft')) : null; }
      if (now) now.hidden = !v.available;
      if (stock) { stock.classList.toggle('is-out', !v.available); var txt = stock.querySelector('[data-text]'); if (txt) txt.textContent = v.available ? (SPS.strings.inStock || 'Sofort lieferbar') : (SPS.strings.soldOut || 'Ausverkauft'); }
      $$('[data-sps-sticky-price]').forEach(function (el) { el.textContent = SPS.money(v.price); });
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('sps:variant', { detail: v }));
    }
    selects.forEach(function (s) { on(s, 'change', function () { apply(current()); }); });
  }

  /* ---------- Icons (für JS-gerenderte Teile) ---------- */
  SPS.icon = function (name) {
    var paths = {
      cart: '<path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h9.7a1 1 0 0 0 1-.8L21 8H6.5"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17.5" cy="20" r="1.3"/>',
      x: '<path d="M6 6l12 12M18 6L6 18"/>'
    };
    return '<svg class="sps-icon" viewBox="0 0 24 24" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  };

  /* Für sps-theme-b.js */
  SPS._ = { $: $, $$: $$, on: on, initSearch: initSearch, initTabs: initTabs, initGallery: initGallery, initVariants: initVariants, wishSync: wishSync, addFromButton: addFromButton };
})();
